import loadCountriesOptions from './loadCountriesOptions';

const loadExtraData = async () => {
    await loadCountriesOptions();
};

export default loadExtraData;
